import { defineStore } from 'pinia'
import _keyBy from 'lodash.keyby'
import _orderBy from 'lodash.orderby'
import _cloneDeep from 'lodash.clonedeep'
import { DATE_TIME } from '@/constants/date.constants.js'
import { $dayjs } from '@/plugins/dayjs.js'


export const useChatsStore = defineStore('chats', {
  state: () => ({
    rooms: []
  }),
  getters: {
    keyedRooms: (state) => _keyBy(state.rooms, 'slug'),
    allRooms: (state) => state.rooms
  },
  actions: {
    addRooms(newRooms) {
      const { rooms } = this
      const fetchedRooms = rooms.map(_ => _.slug)
      const uniqueNewRooms = (newRooms ?? []).filter(_ => !fetchedRooms.includes(_.slug))
      this.rooms = _cloneDeep(
        _orderBy([...rooms, ...uniqueNewRooms], 'activity_date', 'desc')
      )
    },
    updateRoom(room) {
      const index = this.rooms.findIndex(_ => _.slug === room.slug)
      this.rooms[index] = room
      this.rooms = _cloneDeep(
        _orderBy([...this.rooms], 'activity_date', 'desc')
      )
    },
    async fetchRooms(roomsSlugs) {
      const { rooms } = this
      const fetchedRooms = rooms.map(_ => _.slug)
      const slugsToFetch = roomsSlugs.filter(_ => !fetchedRooms.includes(_))
      if (!slugsToFetch.length) return
      const { data: { data } } = await this.$api.chats.fetch(slugsToFetch)

      this.addRooms(data)
    },
    async getRoomsList(cursor = null) {
      const result = await this.$api.chats.list(cursor)
      const { data: { data } } = result
      this.addRooms(data)
      return result
    },
    onRoomMessageDeleted(room) {
      let updatedRoom = this.rooms.find(_ => _.slug === room)
      // deleted messages in background
      if (!updatedRoom) {
        return
      }
      updatedRoom = _cloneDeep(updatedRoom)
      updatedRoom.chat_messages_count -= 1
      this.updateRoom(updatedRoom)
    },
    async onRoomMessageReceived(room) {
      let updatedRoom = this.rooms.find(_ => _.slug === room)
      if (!updatedRoom) {
        await this.fetchRooms([room])
        return
      }
      updatedRoom = _cloneDeep(updatedRoom)
      updatedRoom.chat_messages_count += 1
      updatedRoom.activity_date = $dayjs.toSystem(new Date(), DATE_TIME)
      this.updateRoom(updatedRoom)
    },
    onRoomMessagesRead({ room, count }) {
      let updatedRoom = this.rooms.find(_ => _.slug === room)
      if (!updatedRoom) {
        return
      }
      updatedRoom = _cloneDeep(updatedRoom)
      updatedRoom.chat_messages_count -= count
      if (updatedRoom.chat_messages_count < 0) {
        updatedRoom.chat_messages_count = 0
      }
      this.updateRoom(updatedRoom)
    },
    onRoomDialogCreated(room) {
      let updatedRoom = this.rooms.find(_ => _.slug === room)
      if (!updatedRoom) {
        return
      }
      updatedRoom = _cloneDeep(updatedRoom)
      updatedRoom.unhandled_dialogs_count += 1
      this.updateRoom(updatedRoom)
    },
    onRoomDialogHandel(room) {
      let updatedRoom = this.rooms.find(_ => _.slug === room)
      if (!updatedRoom) {
        return
      }
      updatedRoom = _cloneDeep(updatedRoom)
      updatedRoom.unhandled_dialogs_count -= 1
      if (updatedRoom.chat_messages_count < 0) {
        updatedRoom.chat_messages_count = 0
      }
      this.updateRoom(updatedRoom)
    }
  }
})
